export default __webpack_public_path__ + "static/media/transfer-points.6061e57c.png";